import React, { useEffect, useState } from "react";
import { IApplicationState } from "../../../redux/reducers";
import { connect } from "react-redux";
import Brand from "./components/brand/";
import Markets from "./components/markets";
import CompanyTab from "./components/company";
import userServices from "../../../services/userService";
import companyServices from "../../../services/companyService";
import { IUser } from "../../../interfaces/user";
import Loader from "../../../components/loader";
import Button from "../../../components/common/button";
import { ListGroup, ListGroupItem, Input, Table, Nav, NavItem } from "reactstrap";
import userService from "../../../services/userService";
import { Trash2, User } from "react-feather";
import { ICompany } from "../../../interfaces/company";
import productTypeService from "../../../services/productTypeService";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { History } from "history";
import ShareProduct from "./components/shareProduct";
import { useDebounce } from "../../../utils/hooks";
import { EMAIL_REGEX } from "./components/companyValidateModal";
import companyService from "../../../services/companyService";
import { confirmUserRemove } from "../../../utils/confirmation";

interface IProps extends RouteComponentProps<{ tab: string }> {
	users: IUser[];
	role: string;
	company: any;
	getAllCompanyUsers: () => Promise<any>;
	addCompanyUser: (email: string) => Promise<any>;
	updateUserRole: (userId: string, role: string) => Promise<any>;
	removeUser: (userId: string) => Promise<any>;
	updateCompanyPlantBased: (plant_based: string) => Promise<any>;
	updateCompanyTypes: (types: { id: string }[]) => Promise<any>;
	removeCompanyType: (id: string) => Promise<any>;
	history: History;
	getCompanyName: (email: any) => Promise<any>;
	subscription_type?: string;
}

const TABS = [
	{
		key: "brands",
		name: "Brands"
	},
	{
		key: "markets",
		name: "Markets"
	},
	{
		key: "company",
		name: "Company Type"
	},
	{
		key: "users",
		name: "Users"
	},
	{
		key: "share",
		name: "Share Product"
	}
];

const Company: React.FC<IProps> = ({
	users,
	role,
	company,
	getAllCompanyUsers,
	addCompanyUser,
	updateUserRole,
	removeUser,
	updateCompanyPlantBased,
	removeCompanyType,
	updateCompanyTypes,
	getCompanyName,
	history,
	subscription_type
}) => {
	const params = new URLSearchParams(history.location.search);
	const tab = params.get("tab");
	const [loading, setLoading] = useState<boolean>(false);
	const [updating, setUpdating] = useState<boolean>(false);
	const [email, setEmail] = useState<string>("");
	const [activeTab, setActiveTab] = useState<string>(tab ? tab : TABS[0].key);
	const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>("");
	const [isSameCompany, setIsSameCompany] = useState<boolean>(false);

	const debouncedSearchTerm = useDebounce(email, 1000);

	const isFreeTier = subscription_type === "free" || subscription_type === "free_trial" || !subscription_type;
	const userLimit = 3;
	const isUserLimitReached = isFreeTier && users.length >= userLimit;

	useEffect(() => {
		setLoading(true);
		getAllCompanyUsers().finally(() => {
			setLoading(false);
		});
	}, []);

	const onAddCompanyUser = () => {
		setLoading(true);
		addCompanyUser(email).finally(() => {
			setEmail("");
			getAllCompanyUsers().finally(() => {
				setLoading(false);
			});
		});
	};

	const onUserRoleChanged = (userId: string, role: string) => {
		setLoading(true);
		updateUserRole(userId, role).finally(() => {
			getAllCompanyUsers().finally(() => {
				setLoading(false);
			});
		});
	};

	const onUserRemove = (userId: string) => {
		const user = users.find((u) => u.id === userId);
		const userName = user ? `${user.first_name} ${user.last_name}` : "this user";

		confirmUserRemove(userName, () => {
			setLoading(true);
			removeUser(userId).finally(() => {
				getAllCompanyUsers().finally(() => {
					setLoading(false);
				});
			});
		});
	};

	const validateEmail = (emailInput: any) => {

		setIsSameCompany(false);
		setIsEmailValid(false);
		if (EMAIL_REGEX.test(emailInput)) {
			setEmail(emailInput);
			setIsEmailValid(true);
		}
	};

	useEffect(() => {
		// Validate email format before making API call
		const isEmailFormatValid = debouncedSearchTerm && EMAIL_REGEX.test(debouncedSearchTerm);
		if (isEmailFormatValid && isEmailValid) {

			getCompanyName(debouncedSearchTerm).then((res: any) => {
				if (res && res.id && res.name && company) {
					setIsSameCompany(res.name === company);
				} else {
					setIsSameCompany(false);
				}
			}).catch(() => {
				// Handle API errors gracefully
				setIsSameCompany(false);
			});
		} else {
			// Reset isSameCompany if email format is invalid
			setIsSameCompany(false);
		}
	}, [debouncedSearchTerm, isEmailValid, company]);
	return (
		<div className="company-page">
			<div className="tab-navigation">
				<Nav tabs className="company-tabs">
					{TABS.filter(t => {
						if (subscription_type === "supplier") {
							return t.key !== "brands" && t.key !== "users";
						}
						return true;
					}).map((t) => {
						return role === "JF_ADMIN" ? (
							t.name !== "Share Product" && (
								<NavItem
									key={t.key}
									className={`nav-link company-tab ${t.key === activeTab ? "active" : ""}`}
									onClick={() => setActiveTab(t.key)}
								>
									{t.name}
								</NavItem>
							)
						) : (
							<NavItem
								key={t.key}
								className={`nav-link company-tab ${t.key === activeTab ? "active" : ""}`}
								onClick={() => setActiveTab(t.key)}
							>
								{t.name}
							</NavItem>
						);
					})}
				</Nav>
			</div>
			{activeTab === "brands" && <Brand />}
			{activeTab === "markets" && <Markets />}
			{activeTab === "company" && (
				<CompanyTab
					removeCompanyType={removeCompanyType}
					updateCompanyTypes={updateCompanyTypes}
					updateCompanyPlantBased={updateCompanyPlantBased}
				/>
			)}
			{activeTab === "users" && (
				<Loader isLoading={loading}>
					<div className="company-users">
						{role !== "COMPANY_USER" && (
							<div className="invite-user-section">
								<div className="invite-user-form">
									<Input
										placeholder={isUserLimitReached ? "User limit reached" : "User Email"}
										disabled={isUserLimitReached}
										className="invite-email-input"
										onChange={(e) => validateEmail(e.target.value)}
									/>
									<Button
										onClick={onAddCompanyUser}
										disabled={
											loading ||
											isUserLimitReached ||
											email === "" ||
											!EMAIL_REGEX.test(email) ||
											!isEmailValid ||
											!isSameCompany
										}
										className="color-white invite-button"
									>
										Invite User
									</Button>
									{isUserLimitReached && (
										<div className="ml-3 d-flex align-items-center" style={{ gap: "10px" }}>
											<span style={{ color: "#e85a73", fontWeight: 600 }}>Limit Exceeded</span>
											<Button
												color="primary"
												size="sm"
												onClick={() => history.push("/app/subscribe")}
												style={{ padding: "6px 12px" }}
											>
												Upgrade
											</Button>
										</div>
									)}
								</div>
								{isEmailValid && (
									<p className={`email-validation ${isSameCompany ? "valid" : "invalid"}`}>
										{isSameCompany && isEmailValid
											? "*Valid Email Address"
											: "*Sorry , the entered email does not belong to your company."}
									</p>
								)}
							</div>
						)}

						<div className="users-table-wrapper">
							<Table borderless className="users-table">
								<tbody>
									{users.map((user: IUser) => {
										return (
											<tr
												key={user.id}
												className={`user-row ${user.disable ? "text-muted" : ""}`}
											>
												<td className="user-info">
													<User className="user-icon" />
													<span className="user-name">
														{user.first_name} {user.last_name}
													</span>
												</td>
												<td className="user-email">{user.email}</td>
												<td className="user-role">
													{role !== "COMPANY_USER" ? (
														<div className="role-dropdown">
															<select
																value={user.role}
																onChange={(e) => {
																	onUserRoleChanged(user.id, e.target.value);
																}}
																className="form-control role-select"
															>
																<option value="COMPANY_ADMIN">COMPANY_ADMIN</option>
																<option value="COMPANY_USER">COMPANY USER</option>
															</select>
														</div>
													) : (
														<span className="user-role-text">{user.role}</span>
													)}
												</td>
												<td className="user-company">{user.company?.name}</td>
												{role !== "COMPANY_USER" && (
													<td className="user-actions">
														<Button
															onClick={() => onUserRemove(user.id)}
															className="btn-danger text-white remove-button"
														>
															<Trash2 size={14} />
														</Button>
													</td>
												)}
											</tr>
										);
									})}
								</tbody>
							</Table>
						</div>
					</div>
				</Loader>
			)}
			{activeTab === "share" && <ShareProduct history={history} />}
		</div>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	users: state.user.users,
	role: state.user.role,
	company: state.user?.profile?.company?.name,
	subscription_type: state.user?.profile?.company?.subscription_type
});

const mapDispatchToProps = {
	getAllCompanyUsers: () => userServices.getAllCompanyUsers(),
	addCompanyUser: (email: string) => userService.addCompanyUser(email),
	updateUserRole: (userId: string, role: string) => userService.updateUserRole(userId, role),
	removeUser: (userId: string) => userService.removeUser(userId),
	updateCompanyPlantBased: (plant_based: string) =>
		companyServices.updateCompanyPlantBased(plant_based),
	updateCompanyTypes: (types: { id: string }[]) => companyServices.updateCompanyType(types),
	removeCompanyType: (id: string) => companyServices.removeCompanyType(id),
	getCompanyName: (email: any) => companyService.getCompanyName(email)
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Company));
